module.exports = __webpack_public_path__ + "static/media/purolatorpack.2150d97d.png";